module.exports = __webpack_public_path__ + "static/landing_splash_boxes-f92574d255085e8ed07952009083145b.jpg";